var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthorized)?_c('app-header'):_vm._e(),_c('router-view',{key:_vm.pageKey})],1)}
var staticRenderFns = []

export { render, staticRenderFns }